var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"app"}},[_c('cookie-popup'),_c('navbar'),_c('div',{staticClass:"wrapper-body bg-home",style:(_vm.section_vh)},[_c('router-view')],1),_c('footer-block')],1)}
var staticRenderFns = []

export { render, staticRenderFns }